module.exports = __webpack_public_path__ + "static/media/warehouse_black.14d347d7.svg";